export default (pageNumber) => (pageNumber > 1 ? `Cтраница ${pageNumber}.` : '');
